import React, { FC } from 'react';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';

export interface IHeader {
  text: string;
}

interface IHeaderProps extends IHeader, IBaseComponent {}

const Header: FC<IHeaderProps> = ({ text }) => {
  return (
    <div className="qred-component qred-header">
      <h6>{text}</h6>
    </div>
  );
};

export default Header;
